import React from 'react';
import './question-selector.css';
import { IconButton } from '../../../../components/icon-button';
import { Paragraph } from '../../../../components/paragraph';
import { OptionIndicator } from './option-indicator';
import classNames from 'classnames';

const QuestionSelector = props => {
    const { options, activeOption, setActiveOption, modalVisible } = props;

    const multipleOptions = options.length > 1;

    const showPreviousOption = () => {
        if (activeOption === 0) {
            setActiveOption(options.length - 1);
        } else {
            setActiveOption(activeOption - 1);
        }
    };

    const showNextOption = () => {
        if (activeOption === options.length - 1) {
            setActiveOption(0);
        } else {
            setActiveOption(activeOption + 1);
        }
    };

    const questionClasses = classNames({
        'question-selector__option': true,
        'question-selector__solo-option': !multipleOptions,
    });

    return (
        <>
            <div className="question-selector">
                {multipleOptions && (
                    <IconButton
                        onClick={() => showPreviousOption()}
                        iconName="previous"
                        size="small"
                        withSpacing={true}
                        isDisabled={modalVisible}
                    />
                )}
                <div className={questionClasses}>
                    <Paragraph
                        colorScheme="dark"
                        withSpacing={false}
                        withIndent={true}
                        textAlign="center"
                    >
                        {options[activeOption].text}
                    </Paragraph>
                </div>
                {multipleOptions && (
                    <IconButton
                        onClick={() => showNextOption()}
                        iconName="next"
                        size="small"
                        withSpacing={true}
                        isDisabled={modalVisible}
                    />
                )}
            </div>
            <OptionIndicator
                optionsLength={options.length}
                activeOption={activeOption}
            />
        </>
    );
};

export { QuestionSelector };
